export enum ContractSignatureType {
    SOLE = 'individual_signature',
    JOINT = 'joint_signature',
    CONDITIONAL_JOINT = 'conditional_joint_signature',
}
